<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app',
  beforeCreate () {
    // 管理后台语言
    const savedDataLocale = localStorage.getItem('dataLocale')
    if (!savedDataLocale) {
      localStorage.setItem('dataLocale', 'zh-CN')
    }
  }
}
</script>

<style>
</style>
